function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

;
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

/* icon/UI 24px/File Type PDF.svg: width 24px x height 24px */
var DlsIconFileTypePdf =
/*#__PURE__*/
function (_CustomElement2) {
  _inherits(DlsIconFileTypePdf, _CustomElement2);

  function DlsIconFileTypePdf() {
    _classCallCheck(this, DlsIconFileTypePdf);

    return _possibleConstructorReturn(this, _getPrototypeOf(DlsIconFileTypePdf).apply(this, arguments));
  }

  _createClass(DlsIconFileTypePdf, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" display=\"block\" pointer-events=\"none\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.86 8c.707 0 1.27.197 1.69.59.42.393.63.927.63 1.6s-.21 1.205-.63 1.595c-.42.39-.983.585-1.69.585H3.79v2.73H2.6V8h3.26zm-2.07.98v2.41h1.87c.42 0 .75-.103.99-.31.24-.207.36-.503.36-.89s-.12-.685-.36-.895c-.24-.21-.57-.315-.99-.315H3.79zm10.407-.53c-.48-.3-1.054-.45-1.72-.45h-2.79v7.1h2.79c.666 0 1.24-.15 1.72-.45.48-.3.845-.718 1.095-1.255.25-.537.375-1.152.375-1.845 0-.693-.125-1.308-.375-1.845a2.873 2.873 0 00-1.095-1.255zm-3.32.55v5.1h1.41c.673 0 1.201-.22 1.585-.66.383-.44.575-1.07.575-1.89 0-.82-.192-1.45-.575-1.89-.384-.44-.912-.66-1.585-.66h-1.41zm7.526 0h3.68V8h-4.87v7.1h1.19v-2.99h3.43v-1h-3.43V9z\" clip-rule=\"evenodd\"/></svg>";
    }
  }], [{
    key: "define",
    value: function define() {
      var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dls-icon-file-type-pdf';

      try {
        window.customElements.define(tagName, this);
      } catch (e) {
        /* console.error(e); */
      }
    }
  }]);

  return DlsIconFileTypePdf;
}(_CustomElement);

export { DlsIconFileTypePdf as default };
DlsIconFileTypePdf.define();